<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @shown="focusSearchTerm"
        >
            <template #modal-title>
                Add Printable
            </template>

            <worksheet-search
                ref="worksheet-search"
                :label="true"
                :article_worksheets="article_worksheets"
                @link="linkWorksheet"
                @unlink="unlinkWorksheet"
            />

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

import WorksheetSearch from '@/components/article/WorksheetSearch'

export default {
    data: () => ({}),
    props: [
        'value',
        'article_worksheets'
    ],
    components: {
        WorksheetSearch
    },
    computed: {
        ...mapState({

        }),
        modal_id () {
            let modal_id = 'attach-worksheets-modal'
            return modal_id
        }
    },
    methods: {
        linkWorksheet (worksheet) {
            this.$emit('link', worksheet)
        },
        unlinkWorksheet (worksheet) {
            this.$emit('unlink', worksheet)
        },
        focusSearchTerm () {
            if (this.$refs['worksheet-search']) {
                this.$refs['worksheet-search'].$refs['search-term'].focus()
            }
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        }
    }
}
</script>
